module.exports = __webpack_public_path__ + "img/yw6.07c2e9b7.jpg";